import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { TICKET_HISTORY_FEATURE_KEY, ticketHistoryReducer } from './+state/ticket-history.reducer';
import { TicketHistoryEffects, TicketHistoryFacade } from './+state';
import { TicketHistoryService } from './ticket-history.service';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forRoot({}),
        StoreModule.forFeature(TICKET_HISTORY_FEATURE_KEY, ticketHistoryReducer),
        EffectsModule.forFeature([TicketHistoryEffects])
    ],
    providers: [TicketHistoryService, TicketHistoryFacade, TicketHistoryEffects]
})
export class TicketHistoryModule {}
